
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/[lang]/volunteer-coordinators",
      function () {
        return require("private-next-pages/mahashivratri/[lang]/volunteer-coordinators/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/[lang]/volunteer-coordinators"])
      });
    }
  